import { useForm, SubmitHandler } from "react-hook-form";
import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import styles from "./ProductRegister.module.css";
import { SupplierData } from "../Suppliers/SupplierTable";
import { useEffect, useState,useContext } from "react";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";

export type ProductRegisterData = {
    productname: string;
    manufacture: string;
    supplier: string;
    moldingsite: string;
    cost: number;
    leftright: string;
    size: string;
    color: string;
    product_type: string;
    base_price?: number;
}

export default function ProductRegister() {
    const navigate = useNavigate();

    const [suppliers, setSuppliers] = useState<SupplierData[]>();
    const [manufactures, setManufactures] = useState<string[]>([]);
    const [moldingsite, setMoldingsite] = useState<string[]>([]);
    const { setAuth } = useContext(AuthContext) as AuthContextType;
    
     useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                    setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                    return navigate("/login");
                }
                 const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
            } catch (error) {
                console.error(error);
            }
        }
        checkAuth();
    }, [navigate, setAuth]);

    useEffect(() => {
        const fetchSupplier = async () => {
            const response = await fetch(`${baseUrl}/getsupplier`,{
                method: "GET",
                credentials: "include",
            })
            const data = await response.json();
            if(data.isAuth===false){
            return 
        }
            setSuppliers(data);
        }

        const fetchManufacture = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            }
            );
            const data = await response.json();
            if(data.isAuth===false){
            return 
        }
            const Manufacture = data.manufacture.map((item: Object) => Object.values(item));
            setManufactures(Manufacture);
        }

        const fetchmoldingsite = async () => {
            const response = await fetch(`${baseUrl}/moldingsite`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            setMoldingsite(data);
        }

        fetchSupplier();
        fetchManufacture();
        fetchmoldingsite();
    }, [ navigate, setAuth])

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm<ProductRegisterData>(
        { mode: 'onBlur' }
    )
const selectedProductType= watch("product_type");


    const onSubmit: SubmitHandler<ProductRegisterData> = async (data) => {
        const datastr = JSON.stringify(data);

        const response = await fetch(`${baseUrl}/createProduct`, {
            method: "POST",
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: datastr
        })
        const resjson = await response.json();
        if(resjson.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
        alert(resjson.message);
        if (resjson.submit) {
            navigate("/Products");
        }
    }

    return (
        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
            <h2 className={styles.h2}>製品の登録</h2>
            <p className={styles.p}>すべての項目を入力してください。</p>
            <p className={styles.p}>製品の名称を入力してください。<br />
                （全角で入力してください。）</p>
            <input type="text"
                {...register("productname",
                    {
                        required: "製品の名称は必須です。",
                        maxLength: {
                            value: 50, message: "50文字以内で入力してください。"
                        },
                        pattern: { value: /^[Ａ-Ｚａ-ｚ\u4E00-\u9FFFぁ-んァ-ヶ０-９ー・　]+$/, message: "全角で入力してください。" },
                    })} className={styles.input} />
            <span>{errors.productname?.message}</span>

            <p className={styles.p}>製品の区分を選択してください。</p>
            <select {...register("product_type", { required: "製品の区分の選択は必須です。" })} className={styles.select}>
                <option value="">--選択--</option>
                <option value="list">リスト内既製品</option>
                <option value="readymade">リスト外既製品</option>
                <option value="not_applicable">保険適用外（自費）製品</option>
            </select>
            <span>{errors.product_type?.message}</span>

            {selectedProductType==="list" && <>
            <p className={styles.p}>リスト内既製品の基準価格を入力してください。<br />
                （半角数字で入力してください。）</p>
            <input type="number" {...register("base_price", {
                required: "リスト内既製品の場合、基準価格の入力は必須です。"
            })} className={styles.input} />
            <span>{errors.base_price?.message}</span></>
            }

            <p className={styles.p}>製品のメーカー名を選択してください。</p>
            <select {...register("manufacture", { required: "メーカーの名称は必須です。" })} className={styles.select}>
                <option value="">--選択--</option>
                {manufactures ? manufactures.map((item, index) => <option key={index} value={item}>{item}</option>) : null}
            </select>
            <span>{errors.manufacture?.message}</span>

            <p className={styles.p}>製品の発注先を選択してください。</p>
            <select {...register("supplier", { required: "必ず選択してください。" })} className={styles.select}>
                <option value="">--選択--</option>
                {suppliers ? suppliers.map((item, index) => (<option key={index} value={item.supplier}>{item.supplier}</option>)) : null}
            </select>
            <span>{errors.supplier?.message}</span>

            <p className={styles.p}>製品の採型区分を選択してください。</p>
            <select {...register("moldingsite", { required: "必ず選択してください。" })} className={styles.select}>
                <option value="">--選択--</option>
                {moldingsite ? moldingsite.map((item, index) => (<option key={index} value={item}>{item}</option>)) : null}
            </select>
            <span>{errors.moldingsite?.message}</span>

            <p className={styles.p}>仕入れ値を入力してください。<br />
                （半角数字で入力してください。）</p>
            <input type="number" {...register("cost", {
                required: "仕入れ値は必須です。"
            })} className={styles.input} />
            <span>{errors.cost?.message}</span>

            <p>左右の有無を選択してください。</p>
            <select {...register("leftright")} className={styles.select}>
                <option value='[""]'>左右無し</option>
                <option value='["左","右"]'>左右有り</option>
            </select>
            <p className={styles.p}>サイズを入力してください。サイズ区分がない場合は未入力で進んでください。<br />
                （半角の　,　で区切ってすべてのサイズを入力してください。<br />
                カナは全角、アルファベットと数字は半角で入力してください。）<br />
                例）S,M,L,LL   S,M-L,ショートS,ショートM-L　等</p>

            <input type="text"
                {...register("size",
                    {
                        maxLength: {
                            value: 50, message: "50字以内で表現してください。"
                        },
                        pattern: { value: /^[\u4E00-\u9FFFA-Zァ-ヶ0-9\-ー,]+$/, message: "アルファベットの大文字、全角カナ、半角数字で入力してください。" },
                    })} className={styles.input} />
            <span>{errors.size?.message}</span>
            <p className={styles.p}>色を入力してください。色区分がない場合は未入力で進んでください。<br />
                （半角の　,　で区切ってすべてのサイズを入力してください。<br />
                全角カナか漢字で入力してください。）<br />
                例）ベージュ、ブラック  等</p>

            <input type="text"
                {...register("color",
                    {
                        maxLength: {
                            value: 20, message: "20字以内で表現してください。"
                        },
                        pattern: {
                            value: /^[\u4E00-\u9FFFァ-ヶー,]+$/, message: "漢字か全角カタカナで入力してください。"
                        },
                    })} className={styles.input} />
            <span>{errors.color?.message}</span>

            <Button type="submit" variant="contained" style={{ margin: 15 }}>登録</Button>
            <Link to="/Products"><Button>キャンセル</Button></Link>
        </form>
    )
}